export {
  collectReportSources,
  DISPLAY_SOURCE_KIND_ORDER,
  DRAWER_SOURCE_KIND_ORDER,
  getReportSourceDomain,
  SOURCE_KIND_LABELS,
  type ReportSourceKind,
  type ReportSourceLink,
  type ReportSourceProduct,
} from '@dupe/common/research-report'
